import React from "react";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";

const STANDARD_FINISHES = ['Black', 'Blue Steel', 'Nickel', 'Stainless Steel'];
const TWO_TONED = 'Two-Toned';
const CERAKOTE = 'Cerakote - Color';
const OTHER = 'Other';

export const parseProductFinish = (storedFinish) => {
	let value = typeof storedFinish === 'string' ? storedFinish : '';
	if (STANDARD_FINISHES.includes(value)) {
		return {type: value, primary: '', secondary: '', detail: ''};
	}

	let twoToned = value.match(/^Two-Toned:\s*(.*?)\s+over\s*(.*)$/);
	if (twoToned) {
		return {type: TWO_TONED, primary: twoToned[1], secondary: twoToned[2], detail: ''};
	}

	if (value.indexOf(`${CERAKOTE}:`) === 0) {
		return {type: CERAKOTE, primary: '', secondary: '', detail: value.substring(CERAKOTE.length + 1).trim()};
	}

	if (value.indexOf(`${OTHER}:`) === 0) {
		return {type: OTHER, primary: '', secondary: '', detail: value.substring(OTHER.length + 1).trim()};
	}

	return value
		? {type: OTHER, primary: '', secondary: '', detail: value}
		: {type: '', primary: '', secondary: '', detail: ''};
};

export const formatProductFinish = ({type, primary = '', secondary = '', detail = ''}) => {
	if (STANDARD_FINISHES.includes(type)) {
		return type;
	}
	if (type === TWO_TONED) {
		return `${TWO_TONED}: ${primary} over ${secondary}`;
	}
	if (type === CERAKOTE || type === OTHER) {
		return `${type}: ${detail}`;
	}
	return '';
};

const ProductFinishFields = ({value, update}) => {
	let finish = parseProductFinish(value);
	let updateFinish = (changes) => update(formatProductFinish({...finish, ...changes}));

	return (
		<div>
			<h4 className="section-title">Colorado DR 7602 Form Information</h4>
			<div className="form-group">
				<TextField
					select
					fullWidth
					margin="dense"
					variant="outlined"
					label="Finish"
					value={finish.type}
					onChange={(event) => updateFinish({type: event.target.value, primary: '', secondary: '', detail: ''})}
				>
					<MenuItem value=""><em>None</em></MenuItem>
					{[...STANDARD_FINISHES, TWO_TONED, CERAKOTE, OTHER].map((option) => (
						<MenuItem key={option} value={option}>{option}</MenuItem>
					))}
				</TextField>
			</div>

			{finish.type === TWO_TONED &&
				<div className="row">
					<div className="col-md-6">
						<TextField
							fullWidth
							margin="dense"
							variant="outlined"
							label="First Color"
							value={finish.primary}
							onChange={(event) => updateFinish({primary: event.target.value})}
							inputProps={{maxLength: 100}}
						/>
					</div>
					<div className="col-md-6 pl-0">
						<TextField
							fullWidth
							margin="dense"
							variant="outlined"
							label="Second Color"
							value={finish.secondary}
							onChange={(event) => updateFinish({secondary: event.target.value})}
							inputProps={{maxLength: 100}}
						/>
					</div>
				</div>
			}

			{(finish.type === CERAKOTE || finish.type === OTHER) &&
				<div className="form-group">
					<TextField
						fullWidth
						margin="dense"
						variant="outlined"
						label={finish.type === CERAKOTE ? 'Cerakote Color' : 'Other Finish'}
						value={finish.detail}
						onChange={(event) => updateFinish({detail: event.target.value})}
						inputProps={{maxLength: 220}}
					/>
				</div>
			}
		</div>
	);
};

export default ProductFinishFields;
